import '../styles/style.scss';


import 'slick-carousel';
import 'pickadate/lib/picker.js';
import 'pickadate/lib/picker.date.js';
import 'pickadate/lib/picker.time.js';

import 'select2';

import GG, {
	ggPopup,
	ggAutoCurrent,
	ggResponsive,
	ggFormsController,
	ggCustomSelect,
	ggCallback,
	ggAmountControl,
	formatNumberWithSpaces
} from 'ggcore';

const init = {
	config: {
		log: true,
		responsiveLgWidth: 'device-width'
	},
	formatNumberWithSpaces
};

GG.use(
	init,
	ggPopup,
	ggAutoCurrent,
	ggResponsive,
	ggFormsController,
	ggCustomSelect,
	ggCallback,
	ggAmountControl
);

const i18n = {
	ru: {
		unknown_error: 'Неизвестная ошибка'
	},
	en: {
		unknown_error: 'Unknown error'
	}
};

const currentLang = $('html').attr('lang') || 'ru';

window.GG = GG;

import Inputmask from 'inputmask';

function requireAll(r) {
	r.keys().forEach(r);
}

// Inject templates only in development mode (for hot-reload)
if (process.env.NODE_ENV === 'development') {
	requireAll(require.context('../', true, /\.pug/));
}

 GG.RESPONSIVE = true;
// GG.CUSTOMSCROLL = null;

$(function () {
	(function scrollMenu() {
		var menuOffset = $('.header__menu').offset().top;
		if ($(window).scrollTop() > menuOffset){
			$('.header__menu').addClass('fixed');
		}
		else {
			$('.header__menu').removeClass('fixed');
		}
		$(window).scroll( function() {
			if ($(window).scrollTop() > menuOffset){
				$('.header__menu').addClass('fixed');
			}
			else {
				$('.header__menu').removeClass('fixed');
			}
		});
	})();

	$('.submenu').each(function (i) {
		$(this).addClass('transition')
	});

	if ($('.form__input_phone').length) {
		if($('html[lang="en"]').length) {
			Inputmask({mask: '+9 (999) 999-99-99'}).mask(document.querySelectorAll('.form__input_phone'));	
		} else {
			Inputmask({mask: '+7 (999) 999-99-99'}).mask(document.querySelectorAll('.form__input_phone'));	
		}
		
	}

	if ($('.select2').length) {
		$('.select2').select2({});
	}

	GG.customSelect($('.custom__select'));

	$(window).scroll(function () {
		scrollLinkShow();
	});

	$(".entry__amount_growups").amountControl({
		wrapper: '.entry__amount_growups',
		child: '.amount',
		control: '.amount__container .amount__control'
	});

	$(".entry__amount_kids").amountControl({
		wrapper: '.entry__amount_kids',
		child: '.amount',
		control: '.amount__container .amount__control'
	});

	function scrollLinkShow() {
		var scroll = $(window).scrollTop();
		if (scroll > 300) {
			$('.totop').addClass('totop_vis');
		} else {
			$('.totop').removeClass('totop_vis');
		}
	}

	$('body').on('click', '.totop', function () {
		$('html, body').animate({scrollTop: 0}, 500);
	});

	if ($('.header__menu .menu__entry .submenu').length) {
		$('.submenu')
			.closest('.menu__entry')
			.addClass('menu__entry_non-empty');
	}

	if ($('.main-form').length) {
		$('.main-form form').formsController({
			validationSuccess: function() {
				var $form = $('.main-form form');

				$.ajax({
					url: $form.data('url'),
					method: 'POST',
					cache: false,
					data: $form.serialize()
				})
				.fail(function( jqXHR, textStatus, errorThrown ) {
					$form.find('.form__error').text(i18n[currentLang].unknown_error);
				})
				.done(function (response) {
					if (response.success) {
						$form.find('.form__container').slideUp();
						$form.find('.form__success').slideDown();

						setTimeout(function () {
							$form.find('.form__success').hide();
							$form.find('.form__input').val('').end().find('.form__container').show();
						}, 7000)

						return;
					}

					var message = response.error || i18n[currentLang].unknown_error;
					$form.find('.form__error').text(message).show();
				});
			}
		})
	}

	if($('.mainpage  .gallery .gallery__list .gallery__entry').length > 3) {
		$('.mainpage  .gallery .gallery__list').slick({
			centerMode: true,
			slidesToShow: 5,
			rows: 0,
			speed: 1000,
			swipe: false,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						speed: 200,
						swipe: true,
						arrows: false,
						dots: true,
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				}
			]
		});
	}

	if(GG.config.responsive && !$('.mainpage').length) {
		$('.gallery .gallery__list').slick({
			centerMode: true,
			slidesToShow: 5,
			rows: 0,
			speed: 1000,
			swipe: false,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						speed: 200,
						swipe: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true
					}
				}
			]
		});
	}


	if ($('.photos__entry_lg').length) {
		$('.photos__entry_lg').closest('.photos__list').css({'min-height': '600px'});
	}

	$('.btn_login').click(function (e) {
		e.preventDefault();
		var $this = $(this);

		$.ajax({
			url: $this.data('check-url'),
			method: 'POST',
			cache: false
		})
		.fail(function() {
			GG.togglePopup('popup-login');
		})
		.done(function (response) {
			console.log(response);
			var isSuccess = response.success && !!response.data.auth && !!response.data.redirect;
			if (isSuccess) {
				window.location.href = response.data.redirect;
			} else {
				GG.togglePopup('popup-login');
			}
		});
	});

	if($('#popup-book').length) {
		$('#popup-book .formsController').formsController({
			validationSuccess: function () {
				var $form = $(this.object[0]);

				$.ajax({
					url: $form.data('url'),
					method: 'POST',
					cache: false,
					data: $form.serialize()
				})
				.fail(function( jqXHR, textStatus, errorThrown ) {
					$form.find('.form__error').text(i18n[currentLang].unknown_error);
				})
				.done(function (response) {
					if (response.success && response.data.send) {
						console.log(response);

						$('#popup-book .formsController').slideUp();
						$('#popup-book .form__success').slideDown();

						return;
					}
					var message = response.error || i18n[currentLang].unknown_error;
					$form.find('.form__error').text(message).show();
				});

			}
		});

		$('.form__input_date').pickadate({
			format: 'ddd, dd mmm yyyy',
			monthsFull: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
			monthsShort: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
			weekdaysFull: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
			weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
			firstDay: ['Понедельник'],
			today: false,
			clear: false,
			close: false,
			min: true,
		});

		$('.form__input_time').pickatime({
			clear: false,
			//interval: 60,
			format: 'HH:i',
		});
	}

	if($('#popup-login').length) {
		$('#popup-login .formsController').formsController({
			validationSuccess: function () {
				console.log(this);
				var $form = $(this.object[0]);
				console.log($form.data());
				console.log($form.serialize());
				$.ajax({
					url: $form.data('url'),
					method: 'POST',
					cache: false,
					data: $form.serialize()
				})
				.fail(function( jqXHR, textStatus, errorThrown ) {
					$form.find('.form__error').text(i18n[currentLang].unknown_error);
				})
				.done(function (response) {
					if (response.success && response.data.redirect) {
						console.log(response);
						window.location.href = response.data.redirect;
						return;
					}
					var message = response.error || i18n[currentLang].unknown_error;
					$form.find('.form__error').text(message).show();
				});
			}
		});
	}

	$('body').on('click', '.js-header-toggle', function (e) {
		e.preventDefault();

		$('.header').toggleClass('vis');
		$('html').toggleClass('ov-hidden');
	});

	$('.cookie .cookie__close').click(function(e) {
		e.preventDefault();

		$(this).closest('.cookie').remove();
	});

	$('.js-btn-callback').click(function (e) {
		e.preventDefault();

		GG.togglePopup('popup-callback');
	});


	GG.$('#popup-callback .formsController').formsController({
		validationSuccess: function () {
			var $form = $('#popup-callback .formsController');
			var action = $form.data('url');
			var data = $form.serialize();

			console.log(data);

			grecaptcha.execute('6LePlWopAAAAALt6nsj4m0PHB1qbAA29y-RMizVr', {action: 'submit'}).then(function(token) {
				data+='&token=' + token;

				$.ajax({
					cache: false,
					dataType: 'json',
					method: 'POST',
					url: action,
					data: data,
					success: function (response) {
						if (response.success) {
							$form.hide().find('.form__error').hide();
							$form.next('.form__success').show();
							setTimeout(function () {
								$form.find('.form__input').val('');
								$form.show();
								$form.next('.form__success').hide();
							}, 4000)
						} else {
							var message = response.error || 'Неизвестная ошибка';
							$form.find('.form__error').html(message)
						}
					},
					error: function(response) {
						$form.find('.form__error').html('Неизвестная ошибка').show();
					}
				})
			});


		}
	});


	GG.$('#popup-callback .formsController').formsController({
		validationSuccess: function () {
			var $form = $('#popup-callback .formsController');
			var action = $form.data('url');
			var data = $form.serialize();

			$.ajax({
				cache: false,
				dataType: 'json',
				method: 'POST',
				url: action,
				data: data,
				success: function (response) {
					if (response.success) {
						$form.hide().find('.form__error').hide();
						$form.next('.form__success').show();
						setTimeout(function () {
							$form.find('.form__input').val('');
							$form.show();
							$form.next('.form__success').hide();
						}, 4000)
					} else {
						var message = response.error || 'Неизвестная ошибка';
						$form.find('.form__error').html(message).show();
					}
				},
				error: function(response) {
					$form.find('.form__error').html('Неизвестная ошибка').show();
				}
			})
		}
	});

	if($('.cabinet-status').length) {
		(function setCounterItems(){
			let $parent = $('.cabinet-status .status__next .next__counter');
			let daysLived = $parent.data('days-lived');
			let daysLeft = $parent.data('days-left');
			let daysOverall = daysLived + daysLeft;
			let daysItems = $parent.find('div:visible');
			let daysIndex = (daysLived / daysOverall).toFixed(2);

			let itemsCount = parseInt(daysItems.length * daysIndex);
			
			console.log(daysItems.length, daysIndex, itemsCount);

			for (let i = 0; i < itemsCount; i++) {
				$(daysItems[i]).addClass('yellow');
			}
		})();
	}

	$('.js-recovery-toggle').click(function (e) {
		e.preventDefault();

		if($(this).closest('#popup-login').length) {
			GG.togglePopup('popup-login');
		}

		GG.togglePopup('popup-recovery');
	});

	if($('#popup-recovery').length) {
		GG.$('#popup-recovery .formsController').formsController({
			validationSuccess: function () {
				let $form = $('#popup-recovery .formsController');
				let action = $form.data('url');
				let data = $form.serialize();

				$.ajax({
					cache: false,
					dataType: 'json',
					method: 'POST',
					url: action,
					data: data,
					success: function (response) {
						console.log(response);
						if (response.success) {
							$form.hide().find('.form__error').hide();
							$form.next('.form__success').show();
						} else {
							let message = response.error || 'Неизвестная ошибка';
							$form.find('.form__error').html(message).show();
						}
					},
					error: function(response) {
						$form.find('.form__error').html('Неизвестная ошибка').show();
					}
				})
			}
		});
	}

	GG.callback('popupClosed.info',
		function(element){
			setCookie('hidePopup', 'yes', 3);
		}
	);


	if (!getCookie('hidePopup')) {
		setTimeout(function () {
			GG.togglePopup('popup-info')
		}, 3000)
	}

	if (!getCookie('showAward')) {
		$('.award-popup').addClass('vis');
	}

	$('.award-popup__close').click(function (e) {
		e.preventDefault();

		$('.award-popup').removeClass('vis');
		setCookie('showAward', 'yes', 10);
	});

});


function getCookie(name) {
	let matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
	return matches ? decodeURIComponent(matches[1]) : undefined
}


// уcтанавливает cookie
function setCookie(name,value,days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}